import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PostingCard } from "./postingCard";
import { Post } from "./PostModel";
import Pagination from "./pagination";
import defaultAxios from 'axios';
import { backendUrl, imageDeleteUrl, imageUploadUrl } from "../../../common/constantVarialble";
import Tiptap from "./tiptap";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import HashTagInput from "./hashTagInput";
import { useAuth } from "../../../AuthContext";
import '../../../styles/global.css'
import { Color } from '@tiptap/extension-color'
import ListItem from '@tiptap/extension-list-item'
import TextStyle from '@tiptap/extension-text-style'
import { EditorContent, EditorProvider, useCurrentEditor, useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Heading from '@tiptap/extension-heading'
import Placeholder from "@tiptap/extension-placeholder";
import axios from "axios";
import Image from "@tiptap/extension-image";
import { TextEditMenuBar } from "./textEditMenuBar";


const extensions = [
    Color.configure({ types: [TextStyle.name, ListItem.name] }),
    //TextStyle.configure({ types: [ListItem.name] }),
    Heading.configure({
        levels: [1, 2, 3, 4, 5, 6],
    }),
    StarterKit.configure({
        bulletList: {
            keepMarks: true,
            keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
        },
        orderedList: {
            keepMarks: true,
            keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
        },
    }),
    Placeholder.configure({
        placeholder: "Please input your detail",
    }),
    Image.configure({
        inline: true,
        HTMLAttributes: {
            class: "custom-img-class",
        },
    }),
]

const editorProps = {
    attributes: {
        class: 'text-sm leading-6 text-black  focus:outline-none p-6 bg-slate-200 min-h-96 mb-2 rounded-b-md',
    } //p
}






function CreateServicePost() {
    const [title, setTitle] = useState(""); // Title(제목)
    const [imageUrls, setImageUrls] = useState<string[]>([]); // 이미지 배열
    const [imageUrlKeys, setImageUrlKeys] = useState<string[]>([]); // 이미지 키 배열
    const [hashTags, setHashTags] = useState<string[]>([]); // 해시태그 리스트    
    const [promiseDate, setPromiseDate] = useState<Date | null>(new Date()); // 포스팅 예약 날짜
    const { user } = useAuth(); // 포스팅 작성 User ID
    const navigate = useNavigate();

    // Main Editor
    const mainEditor = useEditor({
        editorProps,
        extensions,
        // editable: true,
        // injectCSS: false,
        content: "",
    });

    const getSaveImageList = () => {
        const json = mainEditor?.getJSON();
        let aImageSrc: string[] = [];

        if (json && json.content && json.content.length) {
            for (let i = 0; i < json.content.length; i++) {
                const jsonContent = json.content[i];

                // jsonContent.content가 존재하는지 확인
                if (jsonContent.content) {
                    for (let j = 0; j < jsonContent.content.length; j++) {
                        const jsonElement = jsonContent.content[j];

                        // jsonElement가 존재하고 타입이 'image'인지 확인
                        if (jsonElement && jsonElement.type === "image") {
                            console.log("jsonElement", jsonElement);
                            const imageSrc = jsonElement.attrs?.src;
                            if (imageSrc) {
                                aImageSrc.push(imageSrc);
                            }
                        }
                    }
                }
            }
        }

        return aImageSrc;
    };


    // 게시물 저장(Create)
    const onSaveBtnClick = async () => {
        if (title.trim() == "") {
            alert("제목을 입력하세요");
            return;
        }
        if (mainEditor?.getHTML().trim() == "") {
            alert("본문을 입력하세요");
            return;
        }
        let p_permlink: string = Math.random().toString(36).substring(2);
        let p_content = mainEditor?.getHTML().trim();
        let p_uid: string = user?.uid ?? "";
        let p_hashTagListString: string = `{${hashTags.join(',')}}`;
        let p_imageList = getSaveImageList();
        let p_imageListString: string = `{${p_imageList.join(',')}}`;

        // 삭제할 이미지 키값(실제 저장되지 않는 이미지의 키값)
        let excludedImageKeys: string[] = [];

        // 저장할 이미지 키값
        let saveImageKeys: string[] = [];

        for (let i = 0; i < imageUrlKeys.length; i++) {
            let isKeyContained: boolean = false;
            let l_image_url_key: string = imageUrlKeys[i];

            for (let k = 0; k < p_imageList.length; k++) {
                let l_image_url: string = p_imageList[k];

                // key가 URL에 포함되어 있는지 확인
                if (l_image_url.includes(l_image_url_key)) {
                    isKeyContained = true;
                    break;
                }
            }

            // key가 URL에 포함되어 있는 경우 
            if (isKeyContained) {
                saveImageKeys.push(l_image_url_key);
            }
            // key가 URL에 포함되어 있지 않은 경우 
            else {
                excludedImageKeys.push(l_image_url_key);
            }
        }

        let p_imageKeyListString = `{${saveImageKeys.join(',')}}`


        // console.log("permlink", p_permlink);
        // console.log("title", title);
        // console.log("content", p_content);
        // console.log("uid", p_uid);
        // console.log("hashTagListString", p_hashTagListString);
        // console.log("imageListString", p_imageListString);
        // console.log("p_imageKeyListString", p_imageKeyListString);
        // console.log("excludedImageKeys", excludedImageKeys);
        // console.log("p_imageList", p_imageList);
        // console.log("saveImageKeys", saveImageKeys);
        // console.log("imageUrlKeys", imageUrlKeys);

        // 1. Create Service Post
        const { data } = await axios({
            method: 'post',
            //url: 'http://localhost:5000/api/request/',
            url: backendUrl,
            data: {
                program_id: 'PERCENT-ENG-POSTING-P-CRTSERVICEPOSTING',
                params: {
                    'p_perm_link': p_permlink,
                    'p_title': title,
                    'p_content': p_content,
                    'p_image_urls': p_imageListString,
                    'p_image_url_keys': p_imageKeyListString,
                    'p_tags': p_hashTagListString,
                    'p_promise_date': promiseDate,
                    'p_user_id': p_uid,
                },
                page_index: -1,
            },
        });

        // 2. Dangling Image 데이터 삭제
        await axios({
            method: 'post',
            //url: 'http://localhost:5000/api/request/',
            url: imageDeleteUrl,
            data: {
                params: {
                    'delete_image_keys': excludedImageKeys,
                },
            },
        });


        // 3. 저장된 포스팅 페이지로 이동
        navigate(`/admin/posting?permlink=${p_permlink}`);

    }




    return <div className="flex flex-1 min-h-screen bg-gray-800 py-12 px-24 flex-col items-center">
        <div className="w-2/3">
            <div className="flex flex-row items-center justify-between mb-6 pb-6 border-b border-gray-500">
                <div className='flex flex-row gap-x-3 items-center'>
                    <p className="text-gray-200 text-xl font-bold">예약 포스팅 날짜 :</p>
                    <DatePicker
                        className="px-2 py-1 rounded border-none bg-slate-200"
                        dateFormat='yyyy.MM.dd' // 날짜 형태
                        shouldCloseOnSelect // 날짜를 선택하면 datepicker가 자동으로 닫힘
                        selected={promiseDate}
                        onChange={(date) => setPromiseDate(date)}
                        onKeyDown={(e) => {
                            e.preventDefault();
                        }}
                    />
                </div>
                <div className="flex flex-row gap-x-2">
                    <button className="group relative h-10 w-40 overflow-hidden rounded-2xl bg-cyan-500 text-lg font-bold text-white" onClick={onSaveBtnClick}>
                        Save
                        <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                    </button>
                </div>
            </div>
            <div className="mb-2">
                <input
                    className="text-sm w-full px-2 py-2 my-4 h-fit rounded main-input outline-none bg-slate-200"
                    id="inputTitle"
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="제목을 입력해주세요"
                    required
                />
                <TextEditMenuBar
                    imageUrls={imageUrls}
                    setImageUrls={setImageUrls}
                    imageUrlKeys={imageUrlKeys}
                    setImageUrlKeys={setImageUrlKeys}
                    editor={mainEditor}
                />
                <EditorContent editor={mainEditor} />
                <HashTagInput
                    hashState={hashTags}
                    hashStateUpdate={setHashTags}
                />
            </div>
        </div>
    </div>
}

export { CreateServicePost };

/**
                 <EditorProvider
                    editorProps={editorProps}
                    slotBefore={<MenuBar imageUrls={imageUrls} setImageUrls={setImageUrls} imageUrlKeys={imageUrlKeys} setImageUrlKeys={setImageUrlKeys} />}
                    extensions={extensions}
                    content={``}
                /> 
 

                                <EditorProvider
                    editorProps={editorProps}
                    slotBefore={<MenuBar imageUrls={imageUrls} setImageUrls={setImageUrls} imageUrlKeys={imageUrlKeys} setImageUrlKeys={setImageUrlKeys} />}
                    extensions={extensions}
                    content={<EditorContent editor={mainEditor} />}
                />
 */
